import Repository from '../axios'
import {defaultPagination} from "@/constants/config";

const  resource = "/landlord/tenants";

export default {
  get(pageNumber = 1, filterQuery, pagination = defaultPagination, sort) {
    return Repository.get(`${resource}?paginate=${pagination}&page=${pageNumber}&sort=${sort}&${filterQuery}`)
  },
  getTenantDetails(id){
    return Repository.get(`${resource}/${id}`)
  },
  createTenant(payload){
    return Repository.post(`${resource}`, payload)
  },
  deleteTenant(id, payload){
    return Repository.delete(`${resource}/${id}`, {data : payload})
  },
  updateTenant(staff_id, payload){
    return Repository.put(`${resource}/${staff_id}`, payload)
  },
  updateCreateTenantAdditionalDetails(id, payload) {
    return Repository.post(`/landlord/tenant/${id}/additional`, payload)
  },
  getTenantUsersList(tenant_id, pageNumber = 1, filterQuery, pagination = defaultPagination, sort) {
    return Repository.get(`/landlord/tenant/${tenant_id}/staff_users?paginate=${pagination}&page=${pageNumber}&sort=${sort}&${filterQuery}`)
  },
  resendTenantUsersWelcomeEmail(email) {
    return Repository.put(`/landlord/tenant/${email}/resend_welcome_email`)
  },
  resendTenantStaffUserWelcomeEmail(tenant_id, email) {
    return Repository.put(`/landlord/tenant/${tenant_id}/staff-user/${email}/staff-resend`)
  },
  deployTenant(tenant_id) {
    return Repository.post(`/landlord/tenant/${tenant_id}/deploy`)
  },
  tenantStatusChange(status, tenant_id) {
    return Repository.put(`/landlord/tenant/${tenant_id}/${status}`)
  },
  deleteTenantUser(tenant_id, id) {
    return Repository.delete(`/landlord/tenant/${tenant_id}/staff_users/${id}`)
  },
  restoreTenant(tenant_id){
    return Repository.put(`/landlord/tenant/${tenant_id}/restore`)
  },
  //tenant staff & resources
  createTenantStaff(tenant_id, payload) {
    return Repository.post(`/landlord/tenant/${tenant_id}/staff_users`, payload)
  },
  updateTenantStaff(tenant_id, staff_id, payload) {
    return Repository.put(`/landlord/tenant/${tenant_id}/staff_users/${staff_id}`, payload)
  },
  getTenantRoleList(tenant_id, is_paginate = 0) {
    return Repository.get(`/landlord/tenant/${tenant_id}/staff/roles?is_paginate=${is_paginate}`)
  },
  getTenantDepartmentList(tenant_id, is_paginate = 0) {
    return Repository.get(`/landlord/tenant/${tenant_id}/staff/departments?is_paginate=${is_paginate}`)
  },

  loginAsL2User(tenant_id) {
    return Repository.post(`/landlord/tenant/${tenant_id}/get-tenant-token`)
  },
  //bulk upload templates
  downloadTemplateDocument(tenant_id, url) {
    return Repository.get(`/landlord/tenant/${tenant_id}/bulk-upload/template/${url}`, { responseType:'blob' })
  }

};
